export const sr = {
  common: {
    save: "Сачувај",
    cancel: "Откажи",
    close: "Затвори",
    delete: "Обриши",
    edit: "Измени",
    create: "Креирај",
    update: "Ажурирај",
    loading: "Учитавање",
    error: "Грешка",
    saved: "Сачувано",
    yes: "Да",
    no: "Не",
    all: "Све",
    apply: "Примени",
    signOut: "Одјави се",
    confirm: "Потврди",
    optionalNotes: "Опционе белешке",
    confirmDelete: "Потврди брисање",
    current: "Тренутно",
    ok: "ОК",
    warning: "Упозорење",
    success: "Успешно",
    back: "Назад",
    copied: "Копирано",
    refresh: "Освежи",
    add: "Додај",
    change: "Промени",
    countryCode: "Позивни број",
    none: "Нема",
  },

  auth: {
    login: "Пријава",
    logout: "Одјава",
    register: "Регистрација",
    email: "Email",
    phone: "Телефон",
    password: "Лозинка",
    confirmPassword: "Потврди лозинку",
    firstName: "Име",
    lastName: "Презиме",
    accountName: "Назив налога",
    loginFailed: "Пријава није успела.",
    signInSubtitle: "Управљајте апартманима, резервацијама и гостима.",
    forgotPassword: "Заборавили сте лозинку?",
    forgotPasswordSubtitle:
      "Унесите email и послаћемо вам упутства за ресетовање лозинке.",
    sendResetLink: "Пошаљи линк за ресетовање",
    backToLogin: "Назад на пријаву",
    or: "или",
    loginWithGoogle: "Настави са Google налогом",
    loginWithFacebook: "Настави са Facebook налогом",
    noAccount: "Немате налог?",
    createAccount: "Креирај налог",
    alreadyHaveAccount: "Већ имате налог?",
    registerSubtitle:
      "Креирајте RentPilot налог и почните да управљате смештајем.",
    verifyEmailBanner:
      "Молимо потврдите своју email адресу пре коришћења свих RentPilot функција.",
    resendVerificationEmail: "Пошаљи поново",
    iVerified: "Потврдио сам",
    resetPassword: "Ресетуј лозинку",
    resetPasswordSubtitle: "Унесите нову лозинку за свој RentPilot налог.",
    newPassword: "Нова лозинка",
    invalidResetLink:
      "Линк за ресетовање лозинке није исправан или је непотпун.",
  },

  tabs: {
    calendar: "Календар",
    properties: "Објекти",
    statistics: "Статистика",
    profile: "Профил",
    team: "Тим",
    cleaners: "Тим",
    support: "Подршка",
    cleaningTasks: "Задаци",
    invoices: "Рачуни",
    menu: "Мени",
  },

  cleaners: {
    title: "Тим",
    add: "Додај",
    cleaners: "Чланови тима",
    newCleaner: "Нови члан тима",
    createCleaner: "Креирај члана тима",
    noCleaners: "Још нема чланова тима.",
    schedule: "Распоред",
    noTasks: "Нема задатака чишћења.",
    assignCleaner: "Додели члана тима",
    cleanedHistory: "Историја чишћења",
    noCleanedHistory: "Још нема очишћених јединица.",
    failedCreateCleaner: "Није могуће креирати члана тима.",
    deleteQuestion: "Обрисати {{name}}?",
    description: "Управљајте члановима тима и њиховим приступом апликацији.",
    teamAccess: "Приступ тиму",
    members: "чланова",
    addMemberDescription:
      "Додајте менаџера, посматрача или собарицу у свој налог.",
    roleOverview: "Преглед улога",
    managerDescription:
      "Може управљати резервацијама, објектима, гостима, задацима и тимом.",
    viewerDescription: "Може прегледати календар без управљања подацима.",
    cleanerDescription: "Види само задатке који су додијељени за чишћење.",
  },

  cleaning: {
    myTasks: "Моји задаци",
    today: "Данас",
    upcoming: "Предстојеће",
    done: "Завршено",
    noTasksToday: "Нема задатака за данас.",
    noUpcomingTasks: "Нема предстојећих задатака.",
    noDoneTasks: "Нема завршених задатака.",
    scheduled: "Заказано",
    cleanedAt: "Очишћено у",
    assignedTo: "Додељено",
    unassigned: "Није додељено",
    start: "Почни",
    markCleaned: "Означи као очишћено",
    futureTaskCannotBeCompleted:
      "Овај задатак може бити завршен на заказани дан.",
    status: {
      pending: "На чекању",
      in_progress: "У току",
      done: "Завршено",
      cancelled: "Отказано",
    },
    description:
      "Преглед данашњих задатака, предстојећих чишћења и историје завршених чишћења.",
  },

  calendar: {
    unit: "Јединица",
    noUnits: "Нема јединица",
    filters: "Филтери",
    startDate: "Почетни датум",
    endDate: "Завршни датум",
    thisWeek: "Ова недеља",
    twoWeeks: "Две недеље",
    threeWeeks: "Три недеље",
    thisMonth: "Овај месец",
    occupied: "Заузето",
    unavailable: "Недоступно",
    rangeOverlaps:
      "Изабрани распон датума се преклапа са постојећом резервацијом.",
    occupiedCellMessage: "Ова јединица већ има резервацију на изабрани датум.",
    selectCheckIn: "Изабери check-in",
    selectCheckOut: "Изабери check-out",
    clear: "Очисти",
    multi: "Више",
    single: "Један",
    next7Days: "Следећих 7 дана",
    next14Days: "Следећих 14 дана",
    selectedStart: "Изабрани почетак",
    tapCheckoutDate: "Додирните датум check-out-а за креирање резервације",
    subtitle:
      "Преглед јединица, резервација, плаћања и боравака који покрећу чишћење.",
    available: "Слободно",
    addObjects: "Додај објекте",
    addObjectsDescription:
      "Креирај први објекат и јединицу да започнеш управљање резервацијама.",
    month: "Месец",
    next: "Даље",
    allUnits: "Сви апартмани",
    checkInAfter: "Улаз од 14:00",
    checkOutBefore: "Излаз до 10:00",
    cleaning: "Чишћење",
    private: "Приватно",
    closed: "Затворено",
    today: "Данас",
    fullYear: "Цијела година",
    availableDates: "Слободни термини",
    availableDatesByUnit: "Слободни термини по апартманима",
    shown: "приказано",
    terms: "термина",
    noFreePeriods: "Нема слободних термина",
  },

  booking: {
    newBooking: "Нова резервација",
    bookingDetails: "Детаљи резервације",
    guestFirstName: "Име госта",
    guestLastName: "Презиме госта",
    guest: "Гост",
    phone: "Телефон",
    email: "Email",
    unit: "Јединица",
    checkIn: "Check-in",
    checkOut: "Check-out",
    nights: "Ноћења",
    pricePerNight: "Цена по ноћи",
    total: "Укупно",
    status: "Статус",
    payment: "Плаћање",
    paymentStatus: "Статус плаћања",
    unpaid: "Неплаћено",
    deposit: "Депозит",
    paid: "Плаћено",
    reserved: "Резервисано",
    checkedIn: "Пријављен",
    checkedOut: "Одјављен",
    cancelled: "Отказано",
    notes: "Белешке",
    createBooking: "Креирај резервацију",
    failedCreate: "Није могуће креирати резервацију.",
    guestFirstNamePlaceholder: "Марко",
    guestLastNamePlaceholder: "Марковић",
    phonePlaceholder: "+387...",
    emailPlaceholder: "marko@example.com",
    pricePlaceholder: "45",
    arrivingAround: "Долазак око 18:00",
    currency: "Валута",
    dateRange: "Датуми боравка",
    selectDates: "Изабери датуме",
    selectCheckIn: "Изабери датум check-in-а",
    selectedDateOccupied: "Овај датум је већ заузет.",
    selectedRangeOverlaps:
      "Изабрани датуми се преклапају са постојећом резервацијом.",
    numberOfGuests: "Број гостију",
    checkoutAfterCheckin: "Check-out мора бити након check-in датума.",
    contactGuest: "Контактирај госта",
    invoice: "Рачун",
    whatsapp: "WhatsApp",
    missingEmail: "Овај гост нема email адресу.",
    missingPhone: "Овај гост нема број телефона.",
    noContactInfo: "Овај гост нема email адресу ни број телефона.",
    confirmSendInvoice: "Послати рачун овом госту?",
    invoiceSent: "Рачун је послат.",
    failedSendInvoice: "Слање рачуна није успело.",
    booking: "Резервација",
    editBooking: "Измени резервацију",
    saveBooking: "Сачувај резервацију",
    sendInvoice: "Пошаљи рачун",
    cancelBooking: "Откажи резервацију",
    cancelBookingQuestion:
      "Да ли сте сигурни да желите отказати ову резервацију?",
    bookingCreated: "Резервација је креирана.",
    bookingUpdated: "Резервација је ажурирана.",
    bookingCancelled: "Резервација је отказана.",
    failedUpdate: "Ажурирање резервације није успело.",
    failedCancel: "Отказивање резервације није успело.",
    unitMissing: "Јединица недостаје.",
    emailUnavailable: "Email није доступан.",
    emailSubject: "Информације о резервацији",
    emailBody: "Поздрав, ово су детаљи ваше резервације.",
    whatsappMessage: "Поздрав, ово су детаљи ваше резервације.",
    missingGuestEmail: "Email госта недостаје.",
    confirmSendInvoiceMessage: "Рачун ће бити послат на email адресу госта.",
    checked_in: "Пријављен",
    checked_out: "Одјављен",
  },

  bookingMessages: {
    title: "WhatsApp порука",
    templateOne:
      "Поздрав {{guest}}, ваша резервација за {{unit}} је потврђена од {{checkIn}} до {{checkOut}}.",
    templateTwo:
      "Поздрав {{guest}}, хвала на резервацији. Check-in је {{checkIn}}, а check-out {{checkOut}}.",
    templateThree:
      "Поздрав {{guest}}, радујемо се вашем доласку у {{unit}}. Ваши датуми су {{checkIn}} - {{checkOut}}.",
    templateButton: "Шаблон {{number}}",
    customPlaceholder: "Напишите поруку...",
    openWhatsApp: "Отвори WhatsApp",
    customMessage: "Прилагођена порука",
    invalidPhone: "Неисправан број телефона.",
    missingPhone: "Број телефона недостаје.",
    whatsappUnavailable: "WhatsApp није доступан.",
  },

  properties: {
    title: "Објекти",
    newProperty: "Нови објекат",
    createProperty: "Креирај објекат",
    propertyName: "Назив објекта",
    address: "Адреса",
    city: "Град",
    notes: "Белешке",
    noUnits: "Још нема јединица",
    units: "јединица",
    newUnit: "Нова јединица",
    createUnit: "Креирај јединицу",
    unitName: "Назив јединице",
    type: "Тип",
    capacity: "Капацитет",
    defaultPricePerNight: "Подразумевана цена по ноћи",
    noDefaultPrice: "Нема подразумеване цене",
    guests: "гости",
    disable: "Онемогући",
    enable: "Омогући",
    deleteProperty: "Обриши објекат",
    deletePropertyQuestion:
      "Обрисати {{name}}? Ово ради само ако нема историје резервација.",
    deleteUnit: "Обриши јединицу",
    deleteUnitQuestion:
      "Обрисати ову јединицу? Ако има историју резервација, можете је деактивирати.",
    failedCreateProperty: "Није могуће креирати објекат.",
    failedCreateUnit: "Није могуће креирати јединицу.",
    apartment: "Апартман",
    room: "Соба",
    studio: "Студио",
    house: "Кућа",
    other: "Остало",
    newPropertyPlaceholder: "Sarajevo Apartments",
    addressPlaceholder: "Улица 1",
    cityPlaceholder: "Сарајево",
    notesPlaceholder: "Опционе белешке",
    unitNamePlaceholder: "Апартман А",
    pricePlaceholder: "45",
    capacityPlaceholder: "2",
    pricePerNightShort: "{{price}} / ноћ",
    deletePropertySuccess: "Објекат обрисан.",
    deleteUnitSuccess: "Јединица обрисана.",
    addUnit: "Додај јединицу",
    activeUnits: "активне јединице",
    inactiveUnits: "неактивне јединице",
    calendarSync: "Синхронизација календара",
    calendarSyncHelp:
      "Налепите Airbnb и Booking.com iCal export линкове овде. RentPilot ће увести те календаре и блокирати одговарајуће датуме.",
    airbnbIcalLink: "Airbnb iCal линк",
    bookingIcalLink: "Booking.com iCal линк",
    rentPilotExportLink: "RentPilot export линк",
    rentPilotExportCalendar: "RentPilot export календар",
    rentPilotExportHelp:
      "Копирајте овај линк у Airbnb и Booking.com како би могли блокирати датуме из RentPilot-а.",
    rentPilotExportHelpLong:
      "Налепите овај линк у подешавања спољног календара на Airbnb или Booking.com.",
    airbnbConnected: "Airbnb повезан",
    airbnbNotConnected: "Airbnb није повезан",
    bookingConnected: "Booking.com повезан",
    bookingNotConnected: "Booking.com није повезан",
    noExternalCalendarsConnected: "Нема повезаних спољних календара.",
    copyShareExportLink: "Копирај export линк",
    exportLinkMissing:
      "Export линк недостаје. Backend није вратио calendar_export_url за ову јединицу.",
    exportLinkCopied: "Export линк је копиран.",
    editUnit: "Измени јединицу",
    saveUnit: "Сачувај јединицу",
    noUnitsDescription:
      "Додајте собе/апартмане како би се резервације и задаци чишћења могли повезати са овим објектом.",
    activateUnit: "Активирај јединицу",
    deactivateUnit: "Деактивирај јединицу",
    failedDeleteProperty: "Брисање објекта није успело.",
    failedDeleteUnit: "Брисање јединице није успело.",
    failedUpdateUnit: "Ажурирање јединице није успело.",
  },

  statistics: {
    title: "Статистика",
    revenue: "Приход",
    bookings: "Резервације",
    nights: "Ноћења",
    averageBooking: "Просечна резервација",
    breakdown: "Преглед",
    noStatistics: "Нема статистике за изабране филтере.",
    groupBy: "Групиши по",
    unit: "Јединица",
    property: "Објекат",
    month: "Месец",
    payment: "Плаћање",
    sevenDays: "7 дана",
    fourteenDays: "14 дана",
    thirtyDays: "30 дана",
    thisMonth: "Овај месец",
    allProperties: "Сви објекти",
    allUnits: "Све јединице",
    byUnit: "По јединици",
    byProperty: "По објекту",
    byMonth: "По месецу",
    netProfit: "Нето профит",
    occupancy: "Попуњеност",
    profitMargin: "Профитна маржа",
    expenseRatio: "Однос трошкова",
    revenueByUnit: "Приход по јединици",
    revenueByApartment: "Приход по апартману",
    noRevenueForPeriod: "Нема прихода за изабрани период.",
    noExpensesForPeriod: "Нема трошкова за изабрани период.",
    manualVsRecurringExpenses: "Једнократни и понављајући трошкови",
    cashflow: "Ток новца",
    latestNetProfit: "Последњи нето профит: {{amount}}",
    performanceBreakdown: "Преглед перформанси",
    breakdownMeta: "{{bookings}} резервација · {{nights}} ноћења",
    margin: "Маржа",
    revenueExpensesHint: "{{revenue}} приход · {{expenses}} трошкови",
    expenses: "Трошкови",
    expensesByCategory: "Трошкови по категорији",
    filters: "Филтери",
  },

  expenses: {
    expenses: "Трошкови",
    newExpense: "Нови трошак",
    editExpense: "Измени трошак",
    newRecurringExpense: "Нови понављајући трошак",
    editRecurringExpense: "Измени понављајући трошак",
    manualExpenses: "Једнократни трошкови",
    recurringExpenses: "Понављајући трошкови",
    totalExpenses: "Укупни трошкови",
    noExpenses: "Још нема трошкова.",
    noRecurringExpenses: "Још нема понављајућих трошкова.",
    name: "Назив",
    category: "Категорија",
    categoryPlaceholder: "Чишћење, режије, одржавање...",
    amount: "Износ",
    date: "Датум",
    frequency: "Учесталост",
    monthly: "Месечно",
    yearly: "Годишње",
    interval: "Интервал",
    dayOfMonth: "Дан у месецу",
    startDate: "Почетни датум",
    endDate: "Завршни датум",
    active: "Активно",
    inactive: "Неактивно",
    noProperty: "Нема објекта",
    noUnit: "Нема јединице",
    uncategorized: "Без категорије",
    expensesByCategory: "Трошкови по категорији",
    expensesByType: "Трошкови по типу",
    expensesByUnit: "Трошкови по јединици",
    addExpense: "Додај трошак",
    oneTimeExpense: "Једнократни трошак",
    oneTimeExpenseDescription:
      "Користи за један трошак, нпр. поправку, пешкире или једну куповину.",
    recurringExpense: "Понављајући трошак",
    recurringExpenseDescription:
      "Користи за трошкове који се понављају, нпр. интернет, претплате или месечне потрепштине.",
  },

  profile: {
    title: "Профил",
    firstName: "Име",
    lastName: "Презиме",
    phone: "Телефон",
    saveProfile: "Сачувај профил",
    profileUpdated: "Профил ажуриран.",
    updateEmail: "Ажурирај email",
    currentPassword: "Тренутна лозинка",
    emailUpdated: "Email ажуриран.",
    password: "Лозинка",
    newPassword: "Нова лозинка",
    confirmNewPassword: "Потврди нову лозинку",
    updatePassword: "Ажурирај лозинку",
    passwordUpdated: "Лозинка ажурирана.",
    passwordsDoNotMatch: "Нова лозинка и потврда се не поклапају.",
    language: "Језик",
    signOutQuestion: "Да ли сте сигурни да желите да се одјавите?",
    failedProfileUpdate: "Није могуће ажурирати профил.",
    failedEmailUpdate: "Није могуће ажурирати email.",
    failedPasswordUpdate: "Није могуће ажурирати лозинку.",
    email: "Email",
    emailPlaceholder: "email@example.com",
    phonePlaceholder: "+387...",
    firstNamePlaceholder: "Име",
    lastNamePlaceholder: "Презиме",
    currentPasswordPlaceholder: "Тренутна лозинка",
    newPasswordPlaceholder: "Нова лозинка",
    confirmNewPasswordPlaceholder: "Потврди нову лозинку",
    signOut: "Одјави се",
    currencySettings: "Валута",
  },

  currency: {
    currency: "Валута",
    currencyUpdated: "Валута ажурирана",
    defaultCurrency: "Подразумевана валута",
    bam: "KM",
    eur: "€",
    usd: "$",
    rsd: "RSD",
    failedCurrencyUpdate: "Валута није ажурирана.",
  },

  support: {
    title: "Подршка",
    needSupport: "Потребна вам је подршка?",
    description:
      "Контактирајте нас ако вам треба помоћ око налога, резервација, објеката, тима или претплате.",
    callSupport: "Позови подршку",
    emailSupport: "Пошаљи email подршци",
  },

  subscription: {
    title: "Претплата",
    subtitle: "Изаберите пакет који одговара вашем смештају.",
    currentPlan: "Тренутни пакет",
    freeNotice: "Тренутно користите бесплатни пакет.",
    perMonth: "/ месечно",
    choosePlan: "Изабери пакет",
    manageBilling: "Управљај наплатом",
    upgradeRequired: "Потребна надоградња",
    upgradeRequiredMessage:
      "Достигнут је лимит вашег тренутног пакета. Надоградите претплату.",
    accessWarningTitle: "Приступ RentPilot-у ускоро истиче",

    accessWarningMessage:
      "Ваш приступ RentPilot-у истиче {{date}}. Изаберите или обновите пакет прије тог датума како бисте наставили уносити и мијењати податке.",

    customAccessWarningMessage:
      "Ваш прилагођени RentPilot пакет истиче {{date}}. Контактирајте RentPilot подршку и договорите плаћање прије тог датума како бисте наставили користити апликацију.",

    accessExpiredTitle: "Приступ RentPilot-у је ограничен",

    accessExpiredMessage:
      "Ваша претплата је истекла или није плаћена. И даље можете прегледати постојеће податке, али унос и измјене су онемогућени док уплата не буде евидентирана.",

    customAccessExpiredMessage:
      "Ваш прилагођени RentPilot пакет је истекао или није плаћен. И даље можете прегледати постојеће податке, али унос и измјене су онемогућени. Контактирајте RentPilot подршку како бисте договорили плаћање и поново активирали приступ.",

    contactAccountOwnerMessage:
      "Контактирајте власника налога како би договорио плаћање и поново активирао пуни приступ.",

    viewPlansCta: "Прегледај пакете",

    contactSupportCta: "Контактирај подршку",

    noticeCloseCta: "Разумијем",
    billingPeriod: "период наплате",
    trialExpiresSoonBanner:
      "Ваш пробни период истиче за {{hours}} сати. Да наставите користити RentPilot, одаберите пакет у веб апликацији.",
    trialExpiresSoonCta: "Одабери пакет",
    billingPeriodDescription:
      "Изаберите колико месеци желите да платите унапред.",
    planColumn: "Пакет",
    limitColumn: "Лимит",
    priceColumn: "Цена",
    discountColumn: "Попуст",
    featuresColumn: "Укључено",
    actionColumn: "Акција",
    recommended: "Препоручено",
    discountBadge: "{{discount}}% попуста",
  },

  menu: {
    pricing: "Цене",
    pricingDescription: "Преглед тренутног пакета и опција наплате.",
    currentPlan: "Тренутни пакет",
    pricingComingSoon: "Управљање ценама ће бити повезано овде.",
    myAccount: "Мој налог",
    myAccountDescription: "Профил, email и лозинка.",
    support: "Подршка",
    supportDescription: "Контактирајте подршку или погледајте информације.",
    settings: "Подешавања",
    settingsDescription: "Изглед апликације, језик и валута",
    privacy: "Приватност и подаци о трговцу",
    privacyDescription:
      "Подаци о фирми, корисничкој подршци и заштити приватности.",
  },

  settings: {
    appAppearance: "Изглед апликације",
    fontSize: "Величина фонта",
    fontSmall: "Мало",
    fontMedium: "Средње",
    fontLarge: "Велико",
    fontVeryLarge: "Веома велико",
    bookingColors: "Боје резервација",
    theme: "Тема",
    themeSystem: "Системска",
    themeLight: "Светла",
    themeDark: "Тамна",
  },

  roles: {
    role: "Улога",
    owner: "Власник",
    manager: "Менаџер",
    cleaner: "Собарица",
    viewer: "Посматрач",
    teamMember: "Члан тима",
  },

  invoices: {
    title: "Послати рачуни",
    description: "Преглед послатих рачуна и историје слања.",
    emptyTitle: "Још нема рачуна",
    empty: "Још није послат ниједан рачун.",
    failedLoad: "Није могуће учитати рачуне.",
    sentAt: "Послато",
    status: {
      pending: "На чекању",
      sent: "Послато",
      failed: "Неуспешно",
    },
  },
  accountDeletion: {
    title: "Brisanje računa",
    description:
      "Ovim šaljete zahtjev za trajno brisanje računa. Svi objekti, jedinice, rezervacije, gosti, članovi tima, fakture, zadaci čišćenja, troškovi i postavke povezane s ovim računom bit će obrisani.",
    warning:
      "Brisanje se zakazuje sa sigurnosnim odgodom, ali ovo koristite samo ako ste sigurni.",
    typeDelete: "Upišite DELETE za potvrdu brisanja računa.",
    requestDeletion: "Zatraži brisanje",
    alreadyScheduled: "Brisanje računa je već zakazano za {{date}}.",
    cancelInfo:
      "Zahtjev za brisanje možete otkazati prije zakazanog datuma brisanja.",
    cancelDeletion: "Otkaži zahtjev za brisanje",
    cancelQuestion: "Da li ste sigurni da želite otkazati zahtjev za brisanje?",
    scheduledMessage: "Brisanje računa je zakazano.",
    cancelledMessage: "Zahtjev za brisanje računa je otkazan.",
    failedRequest: "Nije moguće zatražiti brisanje računa.",
    failedCancel: "Nije moguće otkazati brisanje računa.",
  },

  merchant: {
    title: "Подаци о трговцу",
    description:
      "Основни подаци о правном субјекту који пружа и наплаћује RentPilot услугу.",
    legalName: "Пуни назив правног субјекта",
    address: "Адреса",
    businessActivity: "Дјелатност",
    activityCode: "Шифра дјелатности",
    registrationNumber: "Матични број",
    taxNumber: "Порески / ЈИБ број",
    website: "Веб адреса",
    phone: "Контакт телефон",
    email: "Контакт е-пошта",

    customerServiceTitle: "Кориснички сервис",
    customerServiceDescription:
      "За информације о наруџбама и плаћању, рекламације, отказивање услуге и друге упите можете нас контактирати путем наведених података.",

    privacyTitle: "Заштита приватности",
    privacyDescription:
      "RentPilot прикупља само податке потребне за пружање услуге, управљање корисничким налогом, обраду наруџби и плаћања, корисничку подршку и испуњавање законских обавеза. Лични подаци се не продају. Подаци су доступни само овлашћеним лицима и пружаоцима услуга којима су неопходни за извршавање њихових обавеза. Подаци о картици уносе се искључиво на заштићеној страници процесора плаћања и нису доступни нити се чувају у RentPilot систему.",
  },
};
